import { environment } from "../util";
import axios from "axios";
const logPrefix = "[ADPClient][useDeviceStatusService]"
export function useDeviceStatusService() {
  const getDeviceStatus = async (payload:string, cb:any) => {
    try {
    const url =  environment.resolveApiDomain();
      var config = {
        method: 'post',
        url: `${url}/v2/student-data-services/assessments/sessions/devices/status`,
        headers: { 
          'Content-Type': 'application/json', 
          'x-mynaep-request-id': 'c7731e28-c18e-4b9f-b41f-5da9cd9e1e17', 
          'Authorization': 'Basic c2RzLWFwaS1iYXNpYy11c2VyOmlDQU1CRXJJRElsZQ=='
        },
        data : payload
      };
      
      axios(config)
      .then(function (response:any) {
        console.log("response axios device", response);
        cb(response.data);
      })
      .catch(function (error:any) {
        console.log(error);
          cb(error);
      });
      
  }
  catch(e){
    console.log(logPrefix,"Error:",e);
    cb(e);
  }
  }
 return {getDeviceStatus}
}


